<template>
    <DialogSimple
        :open="dialog"
        color="chat-primary"
        description="Todas as informações preenchidas, editadas serão perdidas"
        label-btn-confirm="Sim"
        @update="handleDialog"
    />
    <Teleport to="body">
        <div
            v-if="state.isActive"
            class="fixed top-0 left-0 z-40 flex w-full h-screen bg-black bg-opacity-50"
            :class="state.style.center ? 'items-center justify-center' : '' "
            @click="handleModalToggle({ status: false })"
        >
            <div
                class="fixed"
                :class="[state.style.align ]"
                @click.stop
            >
                <div
                    class="relative  ale-alling"
                    :class="state.style.width"
                >
                    <div
                        class="flex  animate__animated  h-full  "
                        :class=" [state.style.animate, state.style.border , state.style.bg, state.style.mx,]"
                    >
                        <div class="ola flex flex-col w-full ">
                            <Component
                                :is="state.component"
                                :data="state.props"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
    import { defineAsyncComponent, onBeforeUnmount, onMounted, reactive, ref } from 'vue';
    import useModal from '@/composables/useModal'

    const DEFAULT_WIDTH = 'w-96'
    const DEFAULT_BG = 'bg-white dark:bg-neutral-600'
    const DEFAULT_ANIMATE = 'animate__fadeInDown animate__faster'

    export default {
        components:{
            ModalEditActionsAutomation: defineAsyncComponent(() => import('@/views/dash/automations/modal/ModalAutomation.vue')),
            ModalCallsClients: defineAsyncComponent(() => import('@/views/dash/reports/page/clients/components/ModalCallsClients.vue')),
            ModalCall: defineAsyncComponent(() => import('@/views/dash/reports/page/calls/components/ModalCall.vue')),
            ModalCallsById: defineAsyncComponent(() => import('@/views/dash/reports/page/calls/components/ModalCallsById.vue')),
            ModalCallsView: defineAsyncComponent(() => import('@/views/dash/reports/page/calls/components/ModalCallsView.vue')),
            ModalCallsTags: defineAsyncComponent(() => import('@/views/dash/reports/page/calls/components/ModalCallsTags.vue')),
            ModalCallsDepartment: defineAsyncComponent(() => import('@/views/dash/reports/page/calls/components/ModalCallsDepartment.vue')),
            ModalCallsClassification: defineAsyncComponent(() => import('@/views/dash/reports/page/calls/components/ModalCallsClassification.vue')),
            ModalSeeInvoice: defineAsyncComponent(() => import('@/views/dash/settings/busine/SeeInvoice.vue')),
            DialogSimple: defineAsyncComponent(() => import('../dialog/DialogSimple.vue')),
            ModalCallsDay: defineAsyncComponent(() => import('./reportDashboard/index.vue')),
            ModalCallsUser: defineAsyncComponent(() => import('@/views/dash/reports/page/attendants/components/ModalCallsUser.vue')),
            ModalAttendanceByUser: defineAsyncComponent(() => import('@/views/dash/reports/page/attendants/components/ModalAttendanceByUser.vue')),
            ModalAttendanceByAttendance: defineAsyncComponent(() => import('@/views/dash/reports/page/attendants/components/ModalAttendanceByAttendance.vue')),
            ModalCallsTransferUser: defineAsyncComponent(() => import('@/views/dash/reports/page/attendants/components/ModalCallsTransferUser.vue')),
            ModalCallsChannel: defineAsyncComponent(() => import('@/views/dash/reports/page/channels/components/ModalCallsChannel.vue')),
            ModalManagerGroupSla : defineAsyncComponent(() => import('@/views/dash/settings/configurations/ManagerSla.vue')),
            ModalViewSatisfaction: defineAsyncComponent(() => import('@/views/dash/reports/page/satisfaction/components/ModalSatisfactionSurvey.vue')),
            ModalViewClients: defineAsyncComponent(() => import('@/views/dash/reports/page/clients/components/ModalClients.vue')),
            ModalStatusDetail: defineAsyncComponent(() => import('@/views/dash/reports/page/attendants/components/ModalStatusDetail.vue')),
            ModalCallsSatisfactionSurvey: defineAsyncComponent(() => import('@/views/dash/reports/page/satisfaction/components/ModalCallsSatisfactionSurvey.vue')),
            ModalFile: defineAsyncComponent(() => import('@/views/dash/settings/library/ModalFile.vue')),
            ModalChangeLog: defineAsyncComponent(() => import('./changeLog/ManageChangeLog.vue')),
            ModalReportAttendace: defineAsyncComponent(() => import('./reportAttendance/index.vue')),
            ModalLibrary: defineAsyncComponent(() => import('@/components/library/ModalLibrary.vue')),
            instructionActionAutomation: defineAsyncComponent(() => import('./instruction/actionAutomation/index.vue')),
        },
        props:{
            modelValue:{
                type: Object,
                default:() => {},
            },
        },
        setup() {
            const modal = useModal()
            const dialog = ref(false)
            const state = reactive({
                close_dialog: false,
                isActive : false,
                persistent: false,
                component : {},
                props : {},
                style:{
                    border: '',
                    animate : DEFAULT_ANIMATE,
                    center: true,
                    align: '',
                    width: DEFAULT_WIDTH,
                    bg: DEFAULT_BG,
                    mx: '',
                    px: '',
                },
            })

            onMounted(() => {
                modal.listen(handleModalToggle)
            })

            onBeforeUnmount(() => {
                modal.off(handleModalToggle)
            })
            const handleDialog = (value) => {
                dialog.value = false
                if (value) {
                    handleClose()
                }
            }
            const handleClose = () => {
                state.component = {}
                state.persistent = false
                state.close_dialog = false
                state.props = {}
                state.style.border =  ''
                state.style.animate =  DEFAULT_ANIMATE
                state.style.center =  true
                state.style.align = ''
                state.style.width = DEFAULT_WIDTH
                state.style.bg = DEFAULT_BG
                state.style.mx =  ''
                state.style.px =  ''
                state.isActive = false
            }
            const handleModalToggle = (payload) => {
                if (payload.status) {
                    state.component = payload.component
                    state.close_dialog = payload?.dialog ?? false
                    state.persistent = payload?.persistent ?? false
                    state.props = payload.props
                    state.style.animate = payload.style.animate ? payload.style.animate : DEFAULT_ANIMATE
                    state.style.center = payload.style.center ? payload.style.center : true
                    state.style.align = payload.style.align ? payload.style.align : ''
                    state.style.width = payload.style.width ? payload.style.width : DEFAULT_WIDTH
                    state.style.bg = payload.style.bg ? payload.style.bg : DEFAULT_BG
                    state.style.mx = payload.style.mx ? payload.style.mx : ''
                    state.style.px = payload.style.px ? payload.style.px : ''
                    state.isActive = payload.status
                } else {
                    if (payload?.close_persistent) state.persistent = false
                    if (payload?.close_dialog) state.close_dialog = false

                    if (state.close_dialog) handleDialog()
                    if (state.persistent) {
                        return
                    } else {
                        handleClose()
                    }
                }
            }
            return {
                state,
                dialog,
                handleModalToggle,
                handleDialog,
            }
        },
    };
</script>